import React, { useState } from 'react';
import groovy from '../Assets/images/Groovy.mp4';

// import './Accordion.css';

const AccordionItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item">
      <button
        className="accordion-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <span className="accordion-icon">{isOpen ? '−' : '+'}</span>
      </button>
      <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
        {children}
      </div>
    </div>
  );
};

const Accordion = () => {
  return (
    <div className='d-flex max-width-container accordion-wrap mobile-flex'>
        <div>
                     <video autoPlay loop muted playsInline className="bg-video-acc">
              <source src={groovy} type="video/mp4" />
            </video>
        </div>
    <div className="accordion">
      <AccordionItem title="What’s the MOQ?">
        <p>Usually starts at 50 pieces, but depends on the item. DM us for flexibility.</p>
      </AccordionItem>
      <AccordionItem title="Can I get samples?">
        <p>Yes! Happy to send samples before full production.</p>
      </AccordionItem>
      <AccordionItem title="How long does production take?">
        <p>8–10 days standard. Need it faster? We’ll try our best.</p>
      </AccordionItem>
      <AccordionItem title="How long does delivery take?">
        <p>Depends on location, but usually 5–10 days after production.</p>
      </AccordionItem>
    </div>
    </div>
  );
};

export default Accordion;
